export const validateWarehouseForm = (warehouseId?: number): boolean => {
  return warehouseId !== undefined;
};
